import { combineReducers } from "redux"
import plansReducer from "./plans-reducer"
import deviceReducer from "./device-reducer"
import journeyReducer from "./journey-reducer"
import fetchingReducer from "./shared/loading-reducer"
import basketReducer from "./basket-reducer"
import benefitsReducer from "./benefits-reducer"
import extrasReducer from "./extras-reducer"
import conditionReducer from "./condition-reducer"

export default combineReducers({
  basket: basketReducer,
  fetching: fetchingReducer,
  journey: journeyReducer,
  plans: plansReducer,
  devices: deviceReducer,
  benefits: benefitsReducer,
  extras: extrasReducer,
  condition: conditionReducer
})
